export const container ="flex min-h-screen justify-center items-center"
export const formContainer ="w-full md:w-3/5 mx-4"
export const button = "bg-custom-button-green"
export const forgotPara='text-sm text-green-800 font-bold mb-3'
export const buttomDiv = "flex justify-center mt-3"
export const buttomDivPara ="text-sm font-bold"
export const link = "text-green-700"

